
export default {
  name: 'create-note',

  props: {
    participants: {
      type: Array,
      required: false,
    },
    form: {
      type: Object,
      required: true,
    },
    notable: {
      type: Object,
    },
    client: {
      type: Object,
    },
    linkTo: {
      type: String,
    },
  },
  data() {
    return {
      modelableType: [
        {
          value: 'client',
          label: 'Client',
        },
        {
          value: 'case',
          label: 'Case',
        },
        {
          value: 'task',
          label: 'Task',
        },
        {
          value: 'plan',
          label: 'Plan',
        },
      ],
      localLinkTo: this.linkTo,
      localForm: { ...this.form },
      localClient: { ...this.client },
    };
  },
  watch: {
    localForm: {
      deep: true,
      handler(new_val) {
        this.$emit('update:form', new_val);
      },
    },
    localClient: {
      deep: true,
      handler(new_val) {
        this.$emit('update:client', new_val);
      },
    },
    localLinkTo: {
      handler(new_val) {
        this.$emit('update:linkTo', new_val);
      },
    },
  },
};
